import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZebraTemplateService } from './services/zebra-template.service';

@NgModule({
    imports: [CommonModule]
})
export class ZebraPrintModule {
    constructor(@Optional() @SkipSelf() parentModule: ZebraPrintModule) {
        if (parentModule) {
            throw new Error('ZebraPrintModule is already loaded. Import it in the root module only');
        }
    }

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: ZebraPrintModule,
            providers: [
                ZebraTemplateService
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./libs/zebra-print/src/app/zebra-print.module.ts